"use strict";
// (C) 2007-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.toScopedBearRef = exports.toBearRef = void 0;
var sdk_model_1 = require("@gooddata/sdk-model");
/**
 * Converts reference into a format acceptable by the bear backend. URI references are left as-is, while
 * the identifier references have the object type (if any) stripped.
 *
 * @param ref - reference
 * @internal
 */
function toBearRef(ref) {
    if (sdk_model_1.isUriRef(ref)) {
        return ref;
    }
    return { identifier: ref.identifier };
}
exports.toBearRef = toBearRef;
/**
 * Converts scoped reference into a format acceptable by the bear backend. URI references are left as-is, scoped
 * references are left as is, while the identifier references have the object type (if any) stripped.
 *
 * @param ref - reference
 * @internal
 */
function toScopedBearRef(ref) {
    if (sdk_model_1.isLocalIdRef(ref)) {
        return ref;
    }
    return toBearRef(ref);
}
exports.toScopedBearRef = toScopedBearRef;
//# sourceMappingURL=ObjRefConverter.js.map